/* eslint-disable @typescript-eslint/no-explicit-any */
function intercept(
  object: {
    [key: string]: any;
  },
  methodName: string,
  interceptor: (...args: Array<any>) => any,
) {
  let oldMethod = object[methodName];
  let next = oldMethod.bind(object);
  object[methodName] = (...args: Array<any>) => {
    interceptor(next, ...args);
  };
}

intercept(console, 'warn', (next, input, ...other) => {
  if (typeof input === 'string') {
    if (input.match(/^Warning: component(\w+) has been renamed/)) {
      return;
    }
  }
  next(input, ...other);
});

// Disabling this next supression, since I don't think it's needed anymore.

// intercept(console, 'error', (next, input, ...other) => {
//   if (typeof input === 'string') {
//     if (input.match(/^Warning: Unknown prop/)) {
//       return;
//     }
//   }
//   next(input, ...other);
// });
